import {
	createFileRoute,
	Outlet,
	useRouteContext,
} from "@tanstack/react-router";
import { graphql, useLazyLoadQuery } from "react-relay";
import { BottomTabs } from "@/ui/bottom-tabs";
import { TopNav } from "@/ui/topnav";
import { cn } from "@/utils";
import type { route_TopnavQuery } from "./__generated__/route_TopnavQuery.graphql";

export const Route = createFileRoute("/_visibility/_topnav")({
	component: RouteComponent,
});

function RouteComponent() {
	const { club } = useRouteContext({ from: "__root__" });
	const data = useLazyLoadQuery<route_TopnavQuery>(
		graphql`
	query route_TopnavQuery($slug: String!) {
    	club(slug: $slug) {
        ...topnavFragment
        ...bottomTabs_club
        leaderboard: configuration(key: "LEADERBOARD")
    	}
      user {
       ...topnavRightPanel_user
      }
	}
	`,
		{ slug: club?.slug },
	);

	const isAdmin = (club.permissions?.length || 0) > 0;

	return (
		<div
			className={cn(
				"w-full h-full bg-background md:flex md:flex-col md:min-h-dvh md:max-h-dvh",
				isAdmin && "lg:min-h-[calc(100dvh-2rem)] lg:max-h-[calc(100dvh-2rem)]",
			)}
		>
			<TopNav club={data.club} user={data.user || undefined} />

			<div className="flex-1 overflow-y-auto">
				<Outlet />
			</div>

			<BottomTabs club={data.club} />
		</div>
	);
}
